import { logInfo, logWarning } from '@core/logging'

/**
 * Log AB testing related console info
 * @param message
 */
export const logABTestingInfo: typeof logInfo = (...args) =>
  logInfo('ABTest:', ...args)

/**
 * Log AB testing related console warnings
 * @param message
 */
export const logABTestingWarning: typeof logWarning = (...args) =>
  logWarning('ABTest:', ...args)
